export default __webpack_public_path__ + "static/media/change_pw.9f57bdbc.svg";